// BarberMultipleDayBreak.jsx
import React, { useState } from 'react';
import { jwtDecode } from "jwt-decode";
import useAuth from '../../hooks/useAuth';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';

export default function BarberMultipleDayBreak({ setError, fetchAllAppointmentsForBarber }) {
  const [startBreakDate, setStartBreakDate] = useState(null);
  const [endBreakDate, setEndBreakDate] = useState(null);
  const { auth } = useAuth();
  const decoded = auth?.token ? jwtDecode(auth.token) : undefined;
  const axiosPrivate = useAxiosPrivate();
  
  const apiUrl = process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_API_LOCAL
    : process.env.REACT_APP_API;

  function calculateTimeDifference(startTime, endTime) {
    const [startHours, startMinutes] = startTime.split(':').map(Number);
    const [endHours, endMinutes] = endTime.split(':').map(Number);

    if (isNaN(startHours) || isNaN(startMinutes) || isNaN(endHours) || isNaN(endMinutes)) {
      throw new Error('Invalid time value.');
    }

    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;
    return endTotalMinutes - startTotalMinutes;
  }

  const handleMultipleDayBreakSubmit = async () => {
    if (!startBreakDate || !endBreakDate) {
      setError('Izaberi datume za pauzu');
      return;
    }

    try {
      const barberId = decoded.id;
      const start = new Date(startBreakDate);
      const end = new Date(endBreakDate);
      const dates = [];
      
      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        dates.push(new Date(d));
      }

      for (const date of dates) {
        try {
          await axiosPrivate.post(`${apiUrl}/guestAppointment`, {
            appointmentDate: date.toISOString().split('T')[0],
            appointmentTime: "07:00",
            appointmentDuration: calculateTimeDifference("07:00", "22:00"),
            barberId,
            note: 'BREAK',
          });
        } catch (error) {
          console.error(`Error setting break for ${date}:`, error);
        }
      }

      setStartBreakDate(null);
      setEndBreakDate(null);
      fetchAllAppointmentsForBarber(true);
    } catch (error) {
      console.error('Error setting break:', error);
    }
  };

  return (
    <div className="w-full p-4 sm:p-6 bg-neutral-900 rounded-xl">
      <h3 className="text-lg sm:text-xl font-semibold mb-4">Napravi pauzu od više dana</h3>

      <div className="space-y-3 sm:space-y-4">
        {/* Start Date */}
        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium">Početni datum:</label>
          <input
            type="date"
            className="w-full p-2 sm:p-3 bg-neutral-700 text-white rounded-xl border border-neutral-600 focus:border-blue-500 focus:outline-none text-sm"
            value={startBreakDate || ''}
            onChange={(e) => setStartBreakDate(e.target.value)}
          />
        </div>

        {/* End Date */}
        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium">Krajnji datum:</label>
          <input
            type="date"
            className="w-full p-2 sm:p-3 bg-neutral-700 text-white rounded-xl border border-neutral-600 focus:border-blue-500 focus:outline-none text-sm"
            value={endBreakDate || ''}
            onChange={(e) => setEndBreakDate(e.target.value)}
          />
        </div>

        {/* Submit Button */}
        <button
          onClick={handleMultipleDayBreakSubmit}
          className="w-full p-3 sm:p-4 bg-zinc-200 hover:bg-neutral-800 active:bg-neutral-700 text-black hover:text-white rounded-xl font-bold transition touch-manipulation text-sm sm:text-base"
        >
          Napravi pauzu od više dana
        </button>
      </div>
    </div>
  );
}